import { createAction } from '@reduxjs/toolkit';
import { ISeatzSmartfill } from 'types/iSeatzSmartfill';

export const fetchISeatzSmartfill = createAction<{ query: string }>('iSeatzSmartfill/FETCH_ISEATZ_SMARTFILL');
export const setISeatzSmartfill = createAction<ISeatzSmartfill>('iSeatzSmartfill/SET_ISEATZ_SMARTFILL');
export const clearISeatzSmartfill = createAction('iSeatzSmartfill/CLEAR_ISEATZ_SMARTFILL');
